import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function HorizontalList({
  children,
  handleSize = 3.5,
  offset = 0,
  handleOffset = 2,
}: Props) {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const [isStartReached, setIsStartReached] = React.useState(false);
  const [isEndReached, setIsEndReached] = React.useState(false);
  const scrollToX = (x: number) =>
    ref.current &&
    ref.current.scrollTo({ top: 0, left: x, behavior: "smooth" });
  const getVisibleWidth = () => (ref.current ? ref.current.clientWidth : 0);
  const getScrollableWidth = () => (ref.current ? ref.current.scrollWidth : 0);
  const getScrollOffset = () => (ref.current ? ref.current.scrollLeft : 0);
  const hasReachedStart = () => getScrollOffset() === 0;
  const hasReachedEnd = () =>
    getScrollOffset() + getVisibleWidth() >= getScrollableWidth() - offset &&
    getScrollOffset() + getVisibleWidth() <= getScrollableWidth() + offset;
  const resetState = () => {
    setIsEndReached(hasReachedEnd());
    setIsStartReached(hasReachedStart());
  };
  const scrollRight = () => {
    scrollToX(getScrollOffset() + getVisibleWidth());
    resetState();
  };
  const scrollLeft = () => {
    scrollToX(getScrollOffset() - getVisibleWidth());
    resetState();
  };

  React.useEffect(() => {
    resetState();
  }, [ref.current, children]);

  return (
    <div className={styles.horizontalView}>
      <div className={styles.list} ref={ref} onScroll={resetState}>
        {children}
      </div>
      {!isStartReached && (
        <div
          className={classNames(styles.iconBox, styles.left)}
          style={{
            height: `${handleSize}rem`,
            width: `${handleSize}rem`,
            left: `${handleOffset}rem`,
          }}
          onClick={scrollLeft}
        >
          <ArrowIcon className={styles.icon} />
        </div>
      )}
      {!isEndReached && (
        <div
          className={classNames(styles.iconBox, styles.right)}
          style={{
            height: `${handleSize}rem`,
            width: `${handleSize}rem`,
            right: `${handleOffset}rem`,
          }}
          onClick={scrollRight}
        >
          <ArrowIcon className={styles.icon} />
        </div>
      )}
    </div>
  );
}

export { HorizontalList };
